import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './pickerFix.css';
import { installPickerFix } from './utils/pickerFix';

installPickerFix();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
